// extracted by mini-css-extract-plugin
module.exports = {"projectContainer":"projects-module--projectContainer--1sk7w","container":"projects-module--container--8xGec"};